'use strict';

function PerformanceReviewDistributionController($location, performanceReviewService) {
  var vm = this;
  vm.$onInit = $onInit;
  vm.getState = getState;
  vm.showAgreementQuestionnaire = showAgreementQuestionnaire;

  function $onInit() {
    vm.distribution = vm.data || [];
  }

  function getState(completion) {
    if (completion.manager && completion.employee) {
      return 'COMPLETE';
    }

    if (completion.employee) {
      return 'EMPLOYEE';
    }

    if (completion.manager) {
      return 'MANAGER';
    }

    return 'INCOMPLETE';
  }

  function showAgreementQuestionnaire(token) {
    return $location.path(performanceReviewService.urls.agreement.questionnaire.step({ token: token, step: 1 }));
  }
}

module.exports = PerformanceReviewDistributionController;



/*****************
 ** WEBPACK FOOTER
 ** ./src/app/performance-review/performance-review-distribution/performance-review-distribution.controller.js
 ** module id = 291
 ** module chunks = 0
 **/